/* np-signup-inline.js: the home, blog and article "Join the Inner Circle" forms sign people up through Klaviyo (Adam
   22 Oct 2026: "point the home and blog sign-up forms at Klaviyo"), the same route as the sign-up pop-up
   (snippets/np-signup.liquid, assets/np-signup.js).

   Each form sits in a wrapper with data-np-kl="Home" | "The Lab" | "Article". On submit (with JavaScript) the email and,
   where the form has one, the first name go to Klaviyo's public client subscriptions endpoint: the "Email List" (the
   list the pop-up uses, which starts the welcome emails), source "Efectiv <form> sign-up", profile property
   "Sign-up form" = the form's name. Then the form is replaced with "You're in. Check your inbox.": the list starts the
   "EN | Welcome" flow, whose first email goes straight away with the subscriber's own 10% EFECT code (Adam 3 Nov 2026:
   "Unique code."; until then this showed WELCOME10 and applied it). The pop-up is then told to stay away
   (localStorage npsu = done). Without JavaScript the form still posts to Shopify as before.

   List and public key come from the pop-up's markup (#npsu, rendered on every page) so there is one place to change
   them; the fallbacks below are the same values. Analytics: signup_form_submitted (with the form) through npTrack. */
(function () {
  "use strict";
  var cfg = document.getElementById("npsu");
  var LIST = (cfg && cfg.getAttribute("data-list")) || "WnaN4B";
  var COMPANY = (cfg && cfg.getAttribute("data-company")) || "W5iLND";

  function track(name, d) { if (window.npTrack) window.npTrack(name, d || {}); }

  /* EFECT's own terms (Klaviyo coupon: 10%, unique, one order, 7 days); the welcome email says the same */
  function successBlock(email) {
    var box = document.createElement("div");
    box.className = "npsi-ok";
    box.innerHTML =
      '<p class="npsi-ok-h" tabindex="-1">You&rsquo;re in. Check your inbox.</p>' +
      '<p class="npsi-note">Your own 10% code for your first order is on its way to <strong class="npsi-email"></strong>. Use it on one order within 7 days: the button in the email puts it on your basket.</p>';
    box.querySelector(".npsi-email").textContent = email;
    return box;
  }

  [].forEach.call(document.querySelectorAll("[data-np-kl]"), function (wrap) {
    var form = wrap.querySelector("form");
    if (!form) return;
    var where = wrap.getAttribute("data-np-kl");
    var email = form.querySelector('input[type="email"]');
    var first = form.querySelector('input[name="contact[first_name]"]');
    var btn = form.querySelector('button[type="submit"]');
    if (!email || !btn) return;
    var label = btn.textContent;
    var err = document.createElement("p");
    err.className = "npsi-err"; err.setAttribute("role", "alert"); err.hidden = true;
    btn.parentNode.insertAdjacentElement("afterend", err);

    function fail(msg) { err.textContent = msg; err.hidden = false; email.setAttribute("aria-invalid", "true"); email.focus(); }

    /* Caught on window in the capture phase, before anything else sees the submit: Shopify's bot protection
       (window.Shopify.captcha) listens for submits on its customer forms and put up an hCaptcha challenge after a
       Klaviyo sign-up had already worked (live check, 22 Oct 2026), then would post the form to Shopify as well.
       These forms no longer post to Shopify when JavaScript runs, so nothing else should handle the event. */
    window.addEventListener("submit", function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var addr = email.value.trim();
      err.hidden = true; email.removeAttribute("aria-invalid");
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { fail("Please enter a valid email."); return; }
      var attrs = { email: addr, properties: { "Sign-up form": where } };
      var name = first && first.value.trim();
      if (name) attrs.first_name = name;
      btn.disabled = true; btn.textContent = "Signing you up…";
      fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(COMPANY), {
        method: "POST",
        headers: { "content-type": "application/vnd.api+json", accept: "application/vnd.api+json", revision: "2024-10-15" },
        body: JSON.stringify({ data: { type: "subscription", attributes: {
          custom_source: "Efectiv " + where.toLowerCase() + " sign-up",
          profile: { data: { type: "profile", attributes: attrs } }
        }, relationships: { list: { data: { type: "list", id: LIST } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error("Klaviyo " + r.status);
        try { localStorage.setItem("npsu", "done"); } catch (x) {}
        track("signup_form_submitted", { form: where });
        if (window.klaviyo && typeof window.klaviyo.identify === "function") { try { window.klaviyo.identify({ email: addr }); } catch (x) {} }
        /* the form's own Shopify messages and fine print go with it */
        [].forEach.call(wrap.querySelectorAll(".hm-news-success, .na-join-ok, .na-join-err, .nl-sub-ok"), function (n) { n.hidden = true; });
        var box = successBlock(addr);
        form.hidden = true; err.remove();
        form.insertAdjacentElement("afterend", box);
        box.querySelector(".npsi-ok-h").focus({ preventScroll: true });
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        fail("That didn't go through. Please try again.");
      });
    }, true);
  });
})();
